import { api } from "./configs/axiosConfigs"

export const SpecificAttributesAPI = {
    
    getSpecificAttributes: async (data:any) => {
        const response = await api.get(
            '/specificattributes', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    getSpecificAttributesByCompany: async (data:any) => {
        const response = await api.get(
            '/specificattributes/listByCompany', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    getSpecificAttributesByAttribute: async (data:any) => {
        const response = await api.get(
            '/specificattributes/listByattribute', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    createSpecificAttribute: async (data: any) => {
        const response = await api.post(
            '/specificattributes/register', data
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },
    
    editSpecificAttribute: async (idattribute: number, data: any) => {
        const response = await api.patch(
            `/specificattributes/${idattribute}`, data
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
    
    deleteSpecificAttribute: async (idattribute: number) => {
        const response = await api.delete(
            `/specificattributes/${idattribute}`
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
}